import { contractService } from '../_services'

export const contracts = {
  namespaced: true,
  state: {
    all: {}
  },
  actions: {
    getAll ({ commit }, { perpage, page, sortby, descending }) {
      commit('getAllRequest')

      contractService.getAll(perpage, page, sortby, descending)
        .then(
          customers => commit('getAllSuccess', customers),
          error => commit('getAllFailure', error)
        )
    }
  },
  mutations: {
    getAllRequest (state) {
      state.all = { loading: true }
    },
    getAllSuccess (state, contracts) {
      state.all = { items: contracts }
    },
    getAllFailure (state, error) {
      state.all = { error }
    }
  }
}
